export { default } from "./CustomerAddresses";
